import { Card, Grid } from '@mantine/core';
import SkeletonLine from './SkeletonLine';

export default function CRUDCardSkeleton({ cardContentRows = 5 }: { cardContentRows?: number }) {
  return (
    <>
      <Card>
        <Card.Section inheritPadding withBorder py="xs">
          <Grid align="center">
            <Grid.Col span={12}>
              <SkeletonLine />
            </Grid.Col>
          </Grid>
        </Card.Section>
        <Card.Section inheritPadding withBorder py="xs">
          <Grid gutter={0}>
            {Array.from({ length: cardContentRows }).map((_, idx) => {
              return (
                <Grid.Col span={12} key={`${idx}-${cardContentRows}`}>
                  <SkeletonLine />
                </Grid.Col>
              );
            })}
          </Grid>
        </Card.Section>
      </Card>
    </>
  );
}
